import { useState, useEffect } from 'react';
import { fetchCostServices } from '../services/fetchCostServices';
import { TaskData } from '../constants/types';

export const useCostServicesData = (token: string): TaskData | null => {
  const [chartData, setChartData] = useState<TaskData | null>(null);
  useEffect (() => {
    const fetchData = async () => {
      const response = await fetchCostServices(token, new Date().getFullYear());
      if (response) {
        setChartData(response);
      }
    };

    fetchData();
  }, [token]);
  return chartData;
};